import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]

import { computed } from "vue";
import Image from "./image.vue";
import { ILineEmoji } from "@/clinic/typings";

type IContentMessage = {
  type: string;
  content: string;
  emojis?: ILineEmoji[];
};

type EmojiObject = { [key: number]: ILineEmoji };


export default /*#__PURE__*/_defineComponent({
  __name: 'text',
  props: {
    type: null,
    content: null,
    emojis: null
  },
  setup(__props: any) {

const props = __props as {
  type: string;
  content: string;
  emojis?: ILineEmoji[];
};



const createEmojiObject = (emojis: ILineEmoji[]): EmojiObject => {
  return emojis.reduce<EmojiObject>((acc, emoji) => {
    const length = emoji?.length || 0;
    Array.from({ length }, (_, idx) => {
      acc[idx + emoji.index] = emoji;
    });
    return acc;
  }, {});
};

const emojisObject = computed(() => createEmojiObject(props?.emojis || []));

const contentWithLineBreak = (content: string) => content?.replace(/\n/g, "<br>");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content.length, (index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (
          _unref(emojisObject)[index - 1] &&
          index - 1 >= _unref(emojisObject)[index - 1]?.index &&
          index - 1 <= index + (_unref(emojisObject)[index - 1]?.length || 0) - 1
        )
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
              (index - 1 == _unref(emojisObject)[index - 1]?.index)
                ? (_openBlock(), _createBlock(Image, {
                    key: 0,
                    type: "emoji",
                    emoji: _unref(emojisObject)[index - 1],
                    id: _unref(emojisObject)[index - 1]?.id
                  }, null, 8, ["emoji", "id"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              innerHTML: `${contentWithLineBreak(__props.content.charAt(index - 1))}`
            }, null, 8, _hoisted_2))
      ], 64))
    }), 128))
  ]))
}
}

})